import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M2.5 10.5h3v-5h-3v5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M5.5 5.5l3.147-3.147a.5.5 0 01.853.354v10.586a.5.5 0 01-.853.354L5.5 10.5m5.85-4.268l3.536 3.536m-.001-3.536L11.35 9.768"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m8.775-6.401l5.303 5.303m0-5.303l-5.303 5.303"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 31.5h9v-15h-9v15z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5l9.44-9.44c.944-.944 2.56-.274 2.56 1.062v31.756c0 1.336-1.616 2.006-2.56 1.062L16.5 31.5m17.55-12.803l10.607 10.606m-.001-10.606L34.05 29.303"
  }))
};
export var Mute = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});